<template>
  <div class="container">
    <van-sticky z-index="50">
      <van-nav-bar title="填写退货单" left-arrow    @click-left="goBack"/>
    </van-sticky>
  
    <div class="explain" >
      <van-field
        v-model="returnGoodsInfo.returnTrackingNumber"
        label="退货快递单号"
        placeholder="请填写退货的快递单号"
      />
      <van-cell
        is-link
        title="快递公司"
        @click="showPicker = true"
        :value="returnGoodsInfo.returnDeliveryCompany"
      ></van-cell>
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          :value-key="columns.text"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <div class="tuihui">
        <p>退货留言</p>
        <van-field
          v-model="returnGoodsInfo.returnLeaveMessage"
          rows="2"
          autosiz
          type="textarea"
          maxlength="170"
          placeholder="请您详细填写您的退货留言"
          show-word-limit
        />
        <p class="fll">上传图片</p>
        <van-uploader
          v-model="returnFileList"
          :after-read="afterReadGoods"
          :before-delete="deleteImgGoods"
        />
      </div>
    </div>
    <div style="height: 100px"></div>
    <div class="bottom">
      <van-button block @click="submit">提交申请</van-button>
    </div>
  </div>
</template>

<script>
import {  uploadImage,  returnForm } from '@/api/after-sale'
export default {
  data() {
    return {
      applyTpyeShow: false,
      applyTypeName: '请选择',
      goodsStatusShow: false,
      goodsStatusName: '请选择',
      reasonShow: false,
      reasonName: '请选择',
      showPicker: false,
      phone: '',
      columns: [
        { text: 'EMS', value: 'ems' },
        { text: '韵达快递', value: 'yunda' },
        { text: '中通快递', value: 'zhongtong' },
        {
          text: '百世快递',
          value: 'huitongkuaidi',
        },
        { text: '申通快递', value: 'shentong' },
        { text: '顺丰速运', value: 'shunfeng' },
        {
          text: '德邦物流',
          value: 'debangwuliu',
        },
        { text: '圆通速递', value: 'yuantong' },
        { text: '天天快递', value: 'tiantian' },
        { text: '京东物流', value: 'jd' },
      ],
      returnPictureIds: [],
      returnFileList: [],
      returnGoodsInfo: {
        returnDeliveryCompany: '请选择',
        returnDeliveryCompanyCode: '',
        returnLeaveMessage: '',
        returnPictureIds: '',
        returnTrackingNumber: '',
      },
      
    }
  },
  methods: {
    
    afterReadGoods(file) {
      console.log(file)
      var data = new FormData()
      data.append('file', file.file)
      uploadImage(data).then(({ data }) => {
        if (data.code === 200) {
          this.returnPictureIds.push(data.data.id)
          console.log('this.returnPictureIds', this.returnPictureIds)
        }
      })
    },
    deleteImgGoods() {
      this.returnPictureIds.splice(detail.index, 1)
      return true
    },
     onConfirm(item) {
      console.log(item)
      this.returnGoodsInfo.returnDeliveryCompany = item.text
      this.returnGoodsInfo.returnDeliveryCompanyCode = item.value
      this.showPicker = false
    },
  goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '');
        this.$callApp('iOS', 'GoBackAppMethod', '');
      } else {
        this.$router.go(-1);
      }
    },
    submit() {
        const toast = this.$toast.loading({
        message: '提交中',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
       
      if (this.returnPictureIds.length > 0) {
        this.returnGoodsInfo.returnPictureIds = this.returnPictureIds.join(',')
      }
      
      this.returnGoodsInfo.id = this.$route.query.id
      returnForm(this.returnGoodsInfo).then(({ data }) => {
        if (data.code === 200) {
          this.$toast('提交申请成功')
          this.$router.push({ path:'/after-sale/detail',query:{
            id:this.$route.query.id,
          }})
        }
      })
      .finally(() => {
          toast.clear()
        })
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background: rgb(246, 246, 246);
  color: #323233;
}
.refund {
  font-size: 14px;
  background: #fff;
  margin: 10px 0;
  padding: 10px 15px;
  /deep/.van-cell {
    padding: 10px 0;
  }
  /deep/ .van-field__control {
    font-size: 25px;
    font-weight: bold;
    padding: 0;
  }
  p {
    margin: 0;
  }
  span {
    font-size: 12px;
  }
  .meony {
    align-items: center;
    display: flex;
    font-size: 25px;
    font-weight: bold;
  }
}
.explain {
  font-size: 14px;
  background: #fff;
  // margin: 10px 0;
  padding: 0px 15px;
  /deep/ .van-cell {
    padding: 10px 0;
  }
  .fll {
    margin: 10px 0;
  }
  p {
    margin: 0;
  }
}
.bottom {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 10px;
  button {
    background: #ee0a24;
    color: #fff;
    border-radius: 8px;
  }
}
.distance {
  padding: 10px;
}
.tuihui {
  padding: 10px 0 0 0;
}
/deep/.van-field__label {
  color: #323233;
}
</style>